import { useEffect, useState } from "react";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { Show, UserButton, useAuth } from "@clerk/react";
import ViewCounter from "@/ViewCounter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BuyerRow = ({ b }) => (
  <tr data-testid={`buyer-row-${b.session_id}`}>
    <td>{new Date(b.paid_at).toLocaleString()}</td>
    <td>
      <div className="buyer-name">{b.buyer_name || "—"}</div>
      <div className="buyer-email">{b.buyer_email || "—"}</div>
    </td>
    <td>${b.amount.toFixed(2)}</td>
    <td className="buyer-wish">{b.wish || <span className="muted">No wish written yet</span>}</td>
  </tr>
);

const BuyerTable = () => {
  const { getToken } = useAuth();
  const [buyers, setBuyers] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/buyers`, {
          headers: { Authorization: `Bearer ${await getToken()}` },
        });
        setBuyers(data);
      } catch {
        setError("Could not load buyers. Please refresh.");
      }
    })();
  }, [getToken]);

  if (error) return <p className="dream-error" data-testid="buyers-error">{error}</p>;
  if (!buyers) return <p className="muted" data-testid="buyers-loading">Gathering the believers…</p>;

  const total = buyers.reduce((s, b) => s + b.amount, 0);
  return (
    <>
      <div className="buyers-stats">
        <div data-testid="buyers-count"><strong>{buyers.length}</strong> buyers</div>
        <div data-testid="buyers-total"><strong>${total.toFixed(2)}</strong> received</div>
        <div data-testid="buyers-wish-count"><strong>{buyers.filter((b) => b.wish).length}</strong> wishes</div>
      </div>
      {buyers.length === 0 ? (
        <p className="muted" data-testid="buyers-empty">No one has paid yet. The universe is still aligning.</p>
      ) : (
        <div className="buyers-table-wrap">
          <table className="buyers-table" data-testid="buyers-table">
            <thead>
              <tr><th>Paid</th><th>Buyer</th><th>Amount</th><th>Dream</th></tr>
            </thead>
            <tbody>{buyers.map((b) => <BuyerRow key={b.session_id} b={b} />)}</tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default function BuyersPage() {
  return (
    <>
      <Show when="signed-in">
        <div className="buyers-page" data-testid="buyers-page">
          <header className="buyers-header">
            <div>
              <Link to="/" className="buyers-back" data-testid="buyers-home-link">← Back to the portal</Link>
              <h1 className="result-title buyers-title">The Believers</h1>
            </div>
            <UserButton />
          </header>
          <ViewCounter />
          <BuyerTable />
        </div>
      </Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}
